import script from "./VisualEffectWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualEffectWrapper.vue?vue&type=script&setup=true&lang=js"

import "./VisualEffectWrapper.vue?vue&type=style&index=0&id=604e9e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604e9e23"]])

export default __exports__